import palette from 'src/customizations/themes/10-parts/color-schemes/palette';
import { Tenancy } from './types';
const colors = {
    // Dark enough that 10px white text stays readable on the strip.
    [Tenancy.PROD]: palette.red['800'],
    [Tenancy.DEV]: palette.green['900'],
    [Tenancy.TEST]: palette.grey['600'],
};
export default function tenancyBannerColor(id) {
    return colors[id] ?? palette.grey['600'];
}
